import type { CompetitorNearbyPlaceDto } from '@up2stay/up2promo-api-client';
import { Button } from '@up2stay/up2promo-ui';
import { Trash2 } from 'lucide-react';

import type { CompetitorTheaterLabels } from '@/core/components/reputation/competitor-theater-shared';

export function PlaceActions({
  place,
  labels,
  atLimit,
  isAdding,
  isRemoving,
  onTrack,
  onRemove,
}: {
  place: CompetitorNearbyPlaceDto;
  labels: CompetitorTheaterLabels;
  atLimit: boolean;
  isAdding: boolean;
  isRemoving: boolean;
  onTrack: () => void;
  onRemove: () => void;
}) {
  if (place.alreadyTracked) {
    return (
      <Button
        type="button"
        variant="outline"
        disabled={isRemoving}
        onClick={onRemove}
      >
        {labels.remove}
      </Button>
    );
  }
  return (
    <Button
      type="button"
      disabled={isAdding || atLimit}
      onClick={onTrack}
      title={atLimit ? labels.limitReached : undefined}
    >
      {labels.track}
    </Button>
  );
}
